import React from 'react';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { Headline } from './components';

const VisiMisi = () => {
    return (
        <Main>
            <Box>
                <Container>
                    <Headline />
                </Container>
            </Box>
        </Main>
    );
};

export default VisiMisi;
